import { render, staticRenderFns } from "./OrganizeLocationOptions.vue?vue&type=template&id=6cbafb53&scoped=true&"
import script from "./OrganizeLocationOptions.vue?vue&type=script&lang=js&"
export * from "./OrganizeLocationOptions.vue?vue&type=script&lang=js&"
import style0 from "./OrganizeLocationOptions.vue?vue&type=style&index=0&id=6cbafb53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbafb53",
  null
  
)

export default component.exports